const CLIENT_SIDE_NETWORK_ERROR_CHROME = 'Failed to fetch';
const CLIENT_SIDE_NETWORK_ERROR_FIREFOX = 'NetworkError when attempting to fetch resource.';
const CLIENT_SIDE_NETWORK_ERROR_OTHER = 'Network request failed';
/**
 * These errors will be thrown by `fetch`, in the following cases (non-exclusively):
 *
 * 1. When the user is offline / has a network fluctuation
 * 2. When the browser cancels the request to due to navigation, or user action
 * 3. Browser throws a CORS error, etc.
 *
 * @see https://fetch.spec.whatwg.org/#fetch-api - for exhaustive list of cases
 *
 * We have no easy way of identifying or categorizing which of these types of errors are actually
 * causing this to be thrown, or how to address them, hence they will be ignored from being
 * counted as "bad" events for SLOs, and tracked separately.
 */

const CLIENT_SIDE_NETWORK_ERRORS = [CLIENT_SIDE_NETWORK_ERROR_CHROME, CLIENT_SIDE_NETWORK_ERROR_FIREFOX, CLIENT_SIDE_NETWORK_ERROR_OTHER];

const isClientSideNetworkError = (message = '') => CLIENT_SIDE_NETWORK_ERRORS.some(errorMessage => message.includes(errorMessage));

const isIgnorableApolloError = cause => {
  if (cause && 'networkError' in cause) {
    var _apolloError$networkE;

    // $FlowIgnore: We already narrowed this to ApolloError by checking for networkError
    const apolloError = cause;
    return isClientSideNetworkError(apolloError.message) || isClientSideNetworkError((_apolloError$networkE = apolloError.networkError) === null || _apolloError$networkE === void 0 ? void 0 : _apolloError$networkE.message);
  }

  return false;
};

export const isIgnorableGenericTaskSLOEvent = event => {
  var _cause$cause;

  const {
    cause,
    successful
  } = event; // $FlowIgnore: GenericTaskFailureCause can have a 'cause' nested field

  const nestedCause = (_cause$cause = cause === null || cause === void 0 ? void 0 : cause.cause) !== null && _cause$cause !== void 0 ? _cause$cause : null;

  if (!successful && (isIgnorableApolloError(cause) || isIgnorableApolloError(nestedCause))) {
    return true;
  }

  return false;
};